<template>
  <div class="myhome-header__button">
    <template v-if="role === 'ROLE_PRINCIPAL'">
      <h3 class="dea-heading--medium__m">Cerchi un'offerta formativa su <br />misura per la tua Scuola?</h3>
      <Buttons
        class="dea-button dea-button--large dea-button--iconRight"
        icon="go-to"
        data-test="evaluation-copy-trigger"
        @click="$emit('open-evaluation-modal')"
      >
        Esplora l'offerta
      </Buttons>
    </template>
    <template v-else>
      <h3 class="dea-heading--medium__m">
        Vuoi valutare un libro? <br />
        <Links
          :class="['dea-links', 'dea-links--pointer', `dea-links--${linkColor}`]"
          label-class="dea-heading--medium-xs"
          :href="catalogLink"
          icon="go-to"
          target="_blank"
          >Esplora il catalogo</Links
        >
      </h3>
      <Buttons
        class="dea-button dea-button--large dea-button--iconRight"
        icon="copia-digitale"
        data-test="evaluation-copy-trigger"
        @click="$emit('open-evaluation-modal')"
      >
        Richiedi copia digitale
      </Buttons>
    </template>
  </div>
</template>

<script>
import Links from "deascuola-storybook/src/components/elements/Links";
import Buttons from "deascuola-storybook/src/components/elements/Buttons";

export default {
  name: "ButtonEvaluationCopy",
  components: { Buttons, Links },
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    catalogLink: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      default: "ROLE_TEACHER",
    },
  },
};
</script>
